import type { Resource } from '../../';
export const order_orderSummary_subTotal: Resource = {"default":"Subtotal"};
